//主页面
//规避：/manager,/user,/account,/application
export default {
    path: '/',
    component: () => import('@/main/viewer.vue'),
    children:[
        {
            path: '',
            component: () => import('@/main/views/indexV3.vue'),
            meta: {
                title: '首页',
                menu: {
                    name: 'nav_index',
                    show: true
                }
            },
        },
        {
            path: 'download',
            component: () => import('@/main/views/download.vue'),
            meta: {
                title: '下载中心',
                menu: {
                    name: 'nav_down',
                    show: true
                }
            },
        },
        {
            path: 'status',
            component: () => import('@/main/views/status.vue'),
            meta: {
                title: '状态',
                menu: {
                    name: 'nav_state',
                    show: true
                }
            },
        },
        {
            path: 'about',
            component: () => import('@/main/views/about.vue'),
            meta: {
                title: '关于',
                menu: {
                    name: 'nav_about',
                    show: true
                }
            },
        },
        {
            path: 'lsp',
            component: () => import('@/main/views/about.vue'),
            meta: {
                title: 'Low server program',
                menu: {
                    show: false
                }
            },
        },
    ]
}